module.exports = __webpack_public_path__ + "img/icon-quote.e1c799d6.svg";